<template>
    <div class="status-toggle">
        <div class="option-container">
            <div v-for="(option, index) in localOptions"
                :key="index"
                :class="[
                    'status-toggle__option',
                    {
                        'status-toggle__option--active': option.isSelected,
                        'status-toggle__option--disabled': option.isDisabled
                    }
                ]"
                @click="toggleOption(option)"
            >
                {{ option.name }}
            </div>
        </div>
    </div>
</template>

<script>
// Shared Modules
import {
    EventNames,
} from '@shared/utils/analytics-keys';

export default {
    name: 'status-toggle',
    props: {
        options: {
            type: Array,
            default: () => ([]),
        },
        partnerAppData: {
            type: Object,
            default: () => ({}),
        },
        userId: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        localOptions: [],
    }),
    watch: {
        options: {
            immediate: true,
            handler(value) {
                this.localOptions = value;
            },
        },

        $route: {
            immediate: true,
            handler({ path }) {
                const optionByPath = this.localOptions.find(({ path: optionPath = '' }) => path.includes(optionPath));

                if (optionByPath && !optionByPath.isSelected) {
                    this.toggleOption(optionByPath);
                }
            },
        },
    },
    methods: {
        toggleOption(selectedOption) {
            if (selectedOption.isDisabled) {
                return false;
            }

            this.localOptions = this.localOptions.map((option) => ({
                ...option,
                isSelected: (option.name === selectedOption.name),
            }));

            if (Object.keys(this.partnerAppData).length && selectedOption.id === 'digital-collectibles') {
                this.$webTrackingInstance?.sendEvent(
                    EventNames.PartnerDigitalCol,
                    [
                        {
                            key: 'partner',
                            value: this.partnerAppData.id,
                        },
                        {
                            key: 'user',
                            value: this.userId,
                        },
                        {
                            key: 'from',
                            value: 'wallet',
                        },
                    ]
                );
            }

            this.$emit('toggleOption', this.localOptions);
        },
    },
};
</script>

<style lang="scss" scoped>
.status-toggle {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 1rem;
    margin-bottom: 2.5rem;

    &__option {
        color: $cyprus-color;
        font-size: 1.3rem;
        border: 0.1rem solid $french-gray-color;
        padding: 0.5rem 4.5rem;
        border-radius: 2.5rem;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        &:hover {
            cursor: pointer;
        }

        &:first-child {
            border-radius: 2.5rem 0 0 2.5rem;
        }

        &:last-child {
            margin-left: -2rem;
            border-radius: 0 2.5rem 2.5rem 0;
        }

        &--active {
            font-weight: bold;
            color: $daintree-color;
            border-color: $lima-color;
            background-color: $lima-color-opaque;
            z-index: 1;

            &:first-child,
            &:last-child {
                border-radius: 2.5rem;
            }
        }

        &--disabled {
            background: $mercury-color;
            opacity: 0.5;

            &:hover {
                cursor: default;
            }
        }
    }
}

.option-container {
    display: flex;
    border-radius: 2.5rem;
}

.with-shaddow .option-container {
    box-shadow: 1px 4px 25px 5px rgba(0, 0, 0, 0.25);
}
</style>